import React from "react";

class OptionThumb extends React.Component {
  state = { hovered: false };

  handleOnClick = () => {
    const option = this.props.option;
    if (!this.props.isSelected) {
      this.props.onOptionClick(option);
    }
  };

  handleMouseOver = () => {
    this.setState({
      hovered: true,
    });
  };

  handleMouseOut = () => {
    this.setState({
      hovered: false,
    });
  };

  render() {
    let thumb = this.props.option.thumbnail,
      selectedState = "";

    let hoveredState = this.state.hovered ? "hovered" : "";

    if (this.props.isSelected) {
      // Swap svg image with active version
      thumb = this.props.option.thumbnail_active;
      selectedState = "selected";
    }

    let dimensions = "";

    if (this.props.option.display_dimensions) {
      dimensions = this.props.option.display_dimensions;
    } else if (
      this.props.option.product_width_inches &&
      this.props.option.product_height_inches
    ) {
      dimensions = `${this.props.option.product_width_inches} x ${this.props.option.product_height_inches}`;
    } else if (this.props.option.product_width_inches) {
      dimensions = this.props.option.product_width_inches;
    } else if (this.props.option.product_height_inches) {
      dimensions = this.props.option.product_height_inches;
    }

    return (
      <a
        id={`shape-${this.props.option.id}`}
        className={`tool__option tool__option--shape ${selectedState} ${hoveredState}`}
        onClick={this.handleOnClick}
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
      >
        <div className="product-shape__icon">
          <div className="product-shape__svg">
            <img className="product-shape" src={thumb} alt="" />
            <img
              className="product-shape product-shape--hover"
              src={this.props.option.thumbnail_hover}
              alt=""
            />
          </div>
          <div className="product-shape__text">
            {this.props.option.display_name || this.props.option.name}
            <div className="product-shape__dimensions">{dimensions}</div>
          </div>
        </div>
      </a>
    );
  }
}

export default OptionThumb;
